// MiloApplicationForm.jsx
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/MiloApplicationForm.module.css";

const MiloApplicationForm = ({ setStep }) => {
  const fullName = "John Doe";
  const fullEmail = "jane@example.com";
  const [typedName, setTypedName] = useState("");
  const [typedEmail, setTypedEmail] = useState("");
  const timeoutsRef = useRef([]);

  useEffect(() => {
    setTypedName("");
    setTypedEmail("");
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    const typeNextLetter = (index) => {
      if (index < fullName.length) {
        const timeout = setTimeout(() => {
          setTypedName((prev) => prev + fullName[index]);
          typeNextLetter(index + 1);
        }, 40);
        timeoutsRef.current.push(timeout);
      } else {
        const timeout = setTimeout(() => typeNextEmail(0), 500);
        timeoutsRef.current.push(timeout);
      }
    };

    const typeNextEmail = (index) => {
      if (index < fullEmail.length) {
        const timeout = setTimeout(() => {
          setTypedEmail((prev) => prev + fullEmail[index]);
          typeNextEmail(index + 1);
        }, 40);
        timeoutsRef.current.push(timeout);
      }
    };

    typeNextLetter(0);
    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [fullName, fullEmail]);

  return (
    <div className={styles["miloApplicationContent"]}>
      <div className={styles["miloExplainer"]}>
        <h2>Why MILO?</h2>
        <p>
          Finding a home should be <strong>simple, fast, and stress-free</strong>.
          With MILO, you get real-time approvals and one application for all listings.
        </p>
        {/* You can add a benefits list here */}
      </div>
      <div className={styles["miloFormContainer"]}>
        <h3 className={styles["checkingTitle"]}>MILO Universal Rental Application</h3>
        <div className={styles["typingField"]}>
          <label>Full Name</label>
          <input type="text" value={typedName} readOnly className={styles["typingEffect"]}/>
        </div>
        <div className={styles["typingField"]}>
          <label>Email Address</label>
          <input type="email" value={typedEmail} readOnly className={styles["typingEffect"]} />
        </div>
        <div className={styles["loadingBar"]}></div>
        <button className={styles["nextButton"]} onClick={() => setStep(2)}>
          See How Easy Housing Can Be
        </button>
      </div>
    </div>
  );
};

export default MiloApplicationForm;


